import React from 'react';
import {Form} from 'react-bootstrap';

interface SwitchFieldProps {
  name: string;
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  helpText?: string;
  size?: 'sm' | 'lg';
  variant?: 'switch' | 'checkbox';
}

const SwitchField: React.FC<SwitchFieldProps> = ({
    name,
    value,
    onChange,
    label,
    isRequired,
    error,
    touched,
    disabled = false,
    helpText,
    size,
    variant = 'switch',
}) => {
    const hasError = touched && !!error;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.checked);
    };

    return (
        <div>
            <Form.Check
                type={variant}
                id={name}
                name={name}
                label={
                    <span>
                        {label}
                        {isRequired && <span className="text-danger ml-1">*</span>}
                    </span>
                }
                checked={value}
                onChange={handleChange}
                disabled={disabled}
                isInvalid={hasError}
                feedback={error}
                className={`${size ? `form-check-${size}` : ''}`}
            />

            {helpText && (
                <Form.Text className="text-muted ml-4">
                    {helpText}
                </Form.Text>
            )}

            {hasError && (
                <Form.Control.Feedback type="invalid" style={{display: 'block'}}>
                    {error}
                </Form.Control.Feedback>
            )}
        </div>
    );
};

export default SwitchField;
